import { render, staticRenderFns } from "./wallet-deposit.vue?vue&type=template&id=702e7745&scoped=true"
import script from "./wallet-deposit.vue?vue&type=script&lang=js"
export * from "./wallet-deposit.vue?vue&type=script&lang=js"
import style0 from "./wallet-deposit.vue?vue&type=style&index=0&id=702e7745&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702e7745",
  null
  
)

export default component.exports